import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import ConfigUrl from './config/url'
import ConfigError from './config/error'
import ConfigMeta from './config/meta'
import router from './router'
import store from './store'
import localStorage from './local'
import VueLocalStorage from 'vue-localstorage'
import VueAxios from 'vue-axios'
import axios from 'axios'
import moment from 'moment'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

// Init FontAwesome
library.add(fal)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Init Vuetify
Vue.use(Vuetify)

// Init local storage
Vue.use(VueLocalStorage)

// Init axios
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

Vue.prototype.$url = ConfigUrl
Vue.prototype.$error = ConfigError
Vue.prototype.$meta = ConfigMeta
Vue.prototype.$moment = moment

new Vue({
  el: '#app',
  router,
  store,
  localStorage,
  data () {
    return {
    }
  },
  components: { App },
  template: '<App/>'
})
